import React, {Component} from 'react';
import './facebookLiveFeed.css';
// import * as FBLiveActions from './FacebookLiveActions';

class CountDownTimer extends Component{
    constructor(props) {
        super(props);
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.min = 0;
        this.state = {
            sqSize: 200,
            strokeWidth: 14,
            seconds: 0,
            minutes: 0,
            hours: 0,
            days: 0,
            top1: 0,
            top2: 0
        };
    }
    startTimer() {
        if (this.timer === 0) {
          this.timer = setInterval(this.countDown, 1000);
        }
    }
    countDown() {
        // console.log("seconds -- ", this.state.seconds);
        if(this.state.minutes == 0 && this.state.hours == 0 && this.state.days == 0 && (this.state.seconds-1) == 0){
            this.setState({
                seconds: 0,
                minutes: 0,
                hours: 0,
                days: 0
            });
            clearInterval(this.timer);
            setTimeout(function () {
                // console.log("started live session 1");
                window.location.reload();
            }, 100);
        } else {
            if((this.state.seconds - 1) == 0){
                this.setState({
                    seconds: this.state.seconds - 1
                });
            } else{
                if(this.state.seconds == 0){
                    if(this.state.minutes == 0){
                        // console.log("started live session 3");
                        this.setState({
                            seconds: 59,
                            minutes: 59,
                            hours: this.state.hours - 1
                        });
                    } else{
                        this.setState({
                            seconds: 59,
                            minutes: this.state.minutes - 1
                        });
                    }
                }else{
                    this.setState({
                        seconds: this.state.seconds - 1
                    });
                }
            }
        }
    }
    componentDidMount(){
        // debugger;
        if(window.innerWidth > 767){
            this.setState({
                top1: 41,
                top2: 54 
            });
        } else {
            this.setState({
                top1: 40,
                top2: 51 
            });
        }
        // debugger;
        setTimeout(function(){
            let parentHt = document.querySelector(".before-live").offsetHeight;
            let childHt = document.querySelector(".progressbar-section").offsetHeight;
            let top = (parentHt - childHt) / 2;
            document.querySelector(".progressbar-section").style.top = top + "px";
            document.querySelector(".before-live").style.visibility = "visible";
        }, 200);
        // debugger
        let todayDate = new Date();
        let sessDate = new Date(this.props.sessionDate.replace(/-/g,"/"));
        const diffTime = Math.abs(sessDate - todayDate);
        var days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        if(days == 1)
            var hours = 24;
        else 
            var hours = Math.floor(diffTime / (1000 * 60 * 60)) % 24;
        var days = 0;
        const minutes = Math.floor(diffTime / (1000 * 60)) % 60;
        var seconds = Math.ceil(diffTime / 1000) % 60;
        this.min = minutes;
        this.setState({
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        });
        this.startTimer();
    }

    render(){
        const sqSize = this.state.sqSize;
        const radius = (this.state.sqSize - this.state.strokeWidth) / 2;
        const viewBox = `0 0 ${sqSize} ${sqSize}`;
        const dashArray = radius * Math.PI * 2;
        // debugger;
        const dashOffset1 = dashArray - ((dashArray / 1) * 1);
        const dashOffset2 = dashArray - ((dashArray / 24) * (24 - this.state.hours));
        const dashOffset3 = dashArray - ((dashArray / 60) * (60 - this.state.minutes));

        return(
            <div className="progressbar-section">
                <svg className="progressbar days-circle" viewBox={viewBox}>
                    <circle 
                        className="circle-background"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`} />
                    <circle
                        className="circle-progress"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`}
                        // Start progress marker at 12 O'Clock
                        transform={`rotate(-90 ${this.state.sqSize / 2} ${this.state.sqSize / 2})`}
                        style={{
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset1
                            }
                        } />
                    <text
                        className="circle-text B27_white"
                        x="50%"
                        y={`${this.state.top1}%`}
                        dy=".4em"
                        textAnchor="middle">
                        {`${this.state.days}`}
                    </text>
                    <text className="R13_white time-text" x="50%"  y={`${this.state.top2}%`} dy="1.2em" textAnchor="middle">DAYS</text>
                </svg>
                <svg className="progressbar hours-circle" viewBox={viewBox}>
                    <circle 
                        className="circle-background"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`} />
                    <circle
                        className="circle-progress"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`}
                        transform={`rotate(-90 ${this.state.sqSize / 2} ${this.state.sqSize / 2})`}
                        style={{
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset2
                            }
                        } />
                    <text
                        className="circle-text B27_white"
                        x="50%"
                        y={`${this.state.top1}%`}
                        dy=".4em"
                        textAnchor="middle">
                        {`${this.state.hours}`}
                    </text>
                    <text className="R13_white time-text" x="50%"  y={`${this.state.top2}%`} dy="1.2em" textAnchor="middle">HOURS</text>
                </svg>
                <svg className="progressbar minutes-circle" viewBox={viewBox}>
                    <circle 
                        className="circle-background"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`} />
                    <circle
                        className="circle-progress"
                        cx={this.state.sqSize / 2}
                        cy={this.state.sqSize / 2}
                        r={radius}
                        strokeWidth={`${this.state.strokeWidth}px`}
                        transform={`rotate(-90 ${this.state.sqSize / 2} ${this.state.sqSize / 2})`}
                        style={{
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset3
                            }
                        } />
                    <text
                        className="circle-text B27_white"
                        x="50%"
                        y={`${this.state.top1}%`}
                        dy=".4em"
                        textAnchor="middle">
                        {`${this.state.minutes}`}
                    </text>
                    <text className="R13_white time-text" x="50%"  y={`${this.state.top2}%`} dy="1.2em" textAnchor="middle">MINUTES</text>
                </svg>
            </div>
        )
    }
}

export default CountDownTimer;
